module.exports = __webpack_public_path__ + "img/iconoT2C-transparent_v2.0f1ee0c4.png";